import { API_JWT_BASE_URL } from '../http'

export const INDIVIDUAL_MANIFEST_API = `${API_JWT_BASE_URL}/IndividualManifests/`
export const INITIATE_OTAP_API = `${API_JWT_BASE_URL}/IndividualManifests/initiateOtap`
export const CANCEL_OTAP_API = `${API_JWT_BASE_URL}/IndividualManifests/cancelOtap`
export const INITIATE_MULTIPLE_OTAP_API = `${API_JWT_BASE_URL}/IndividualManifests/initiatemultipleotaps`
export const CANCEL_MULTIPLE_OTAP_API = `${API_JWT_BASE_URL}/IndividualManifests/cancelmultipleotaps`

export const INDIVIDUAL_MANIFEST_QUERY_KEYS = {
  INITIATE_OTAP: 'INITIATE_OTAP',
  CANCEL_OTAP: 'CANCEL_OTAP',
  INITIATE_GROUP_OTAP: 'INITIATE_GROUP_OTAP',
  CANCEL_GROUP_OTAP: 'CANCEL_GROUP_OTAP',
  INITIATE_MULTIPLE_OTAP: 'INITIATE_MULTIPLE_OTAP',
  CANCEL_MULTIPLE_OTAP: 'CANCEL_MULTIPLE_OTAP',
  GET_ERROR_DETAIL_LOG: 'GET_ERROR_DETAIL_LOG'
}
